import { apiClient } from '../../axios';
import {
  GetTradingLeaderboardsMeResponse,
  GetTradingLeaderboardsParams,
  GetTradingLeaderboardsResponse,
  GetTradingLeaderboardsTierResponse,
  PutTradingLeaderboardsOptOutParams,
} from './types';

export const getTradingLeaderboardsApi = (params: GetTradingLeaderboardsParams) =>
  apiClient.get<GetTradingLeaderboardsResponse>('/v2/trading-leaderboards', { params });

export const getTradingLeaderboardsMeApi = () =>
  apiClient.get<GetTradingLeaderboardsMeResponse>('/v2/trading-leaderboards/me');

export const putTradingLeaderboardsOptOutApi = (params: PutTradingLeaderboardsOptOutParams) =>
  apiClient.put<PutTradingLeaderboardsOptOutParams>('/v2/trading-leaderboards/opt-out', params);

export const getTradingLeaderboardsTierApi = () =>
  apiClient.get<GetTradingLeaderboardsTierResponse>('/v2/trading-leaderboards/tier');
